import React, { Component } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import "./scss/style.scss";
import { IsLoggedIn } from "./common/utility";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const Layout = React.lazy(() => import("./containers/Layout"));

// Pages
const Login = React.lazy(() => import("./views/PublicPages/Login/Login"));

class App extends Component {
  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              exact
              path="/login"
              render={(props) => <Login {...props} />}
            />
            <Route path="/" render={(props) => IsLoggedIn() ? <Layout {...props} /> : <Redirect to="/login"/>} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
